import { useState } from 'react'
import { SettingOption } from '@/components/AiOptimization/types'



const useConfg = () => {
  const [confgState, setConfig] = useState<SettingOption>({
    tone: 'FORMAL',
    word: '400'
  })
  const [articleState, setArticle] = useState({
    content: '',
    status: 0, // 0 默认 1 生成中 2 结束
  })
  const setConfigState = (val: string, key: string) => {
    setConfig({
      ...confgState,
      [key]: val
    })
  }
  const setArticleStatus = (status: 0 | 1 | 2) => {
    setArticle({
      content: articleState.content,
      status
    })
  }
  return {
    articleState,
    confgState,
    setConfigState,
    setArticleStatus,
  }
}

export default useConfg
